<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import ListLiveClassView from '../lists/ListLiveClassView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  name: 'ModuleLiveClassView',
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'list-live-class-view': ListLiveClassView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-broadcast-tower"
                  title="Todos los En Vivo"
                  subtitle="Administración general de transmisiones en vivo y grabaciones de la plataforma"
                />
                <div class="la5lo1">
                  <list-live-class-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
